import React from 'react'
import { Link } from 'react-router-dom'
import { CategoryBreadcrumbFragment } from '#src/generated/graphql'
import classnames from 'classnames'
import { relativeToAbsoluteUrl } from '#src/services/navigation'
import styles from './styles.css'

interface CategoryBreadcrumbsProps extends React.HTMLAttributes<HTMLDivElement> {
  categories: CategoryBreadcrumbFragment[]
}

const CategoryBreadcrumbs: React.SFC<CategoryBreadcrumbsProps> = ({ categories, className }) => {
  const breadcrumbs = categories.map(category => ({
    displayName: category.pluralDisplayName,
    location: `/c/${category.slug}`
  }))

  // See: https://developers.google.com/search/docs/data-types/breadcrumb
  const linkedData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs.map((crumb, i) => {
      return {
        '@type': 'ListItem',
        position: i,
        name: crumb.displayName,
        item: relativeToAbsoluteUrl(crumb.location)
      }
    })
  }

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(linkedData) }}
      />

      <nav className={classnames(styles.breadcrumbs, className)}>
        <ol className={styles.list}>
          <li className={styles.crumb}>
            <strong>All departments</strong> &rsaquo;
          </li>
          {breadcrumbs.map((breadcrumb, idx) => (
            <li className={styles.crumb} key={breadcrumb.displayName}>
              <Link to={breadcrumb.location} className={styles.crumbLink}>
                {breadcrumb.displayName}
              </Link>
              {idx !== breadcrumbs.length - 1 && <> &rsaquo;</>}
            </li>
          ))}
        </ol>
      </nav>
    </>
  )
}

export default CategoryBreadcrumbs
